module.exports = __webpack_public_path__ + "static/media/shopping-cart-big.2b6d8f7b.svg";